import { ArrowUpRight } from "lucide-react";

export const ServiceCard = ({ service, index, onSelect }) => {
  const Icon = service.icon;
  return (
    <article
      className={`padma-service-card tone-${service.tone}`}
      data-testid={`service-card-${service.id}`}
      style={{ "--service-delay": `${index * 90}ms` }}
    >
      <div className="padma-service-topline">
        <span className="padma-service-icon" aria-hidden="true"><Icon size={23} /></span>
        <span className={`padma-service-status status-${service.tone}`} data-testid={`service-status-${service.id}`}>
          {service.status}
        </span>
      </div>
      <div className="padma-service-copy">
        <h2>{service.title}</h2>
        <p>{service.description}</p>
      </div>
      <button
        type="button"
        className={`padma-service-action action-${service.tone}`}
        data-testid={`service-btn-${service.id}`}
        onClick={() => onSelect(service.id)}
      >
        <span>{service.actionLabel || service.title}</span>
        <ArrowUpRight size={17} aria-hidden="true" />
      </button>
    </article>
  );
};